import { Controller } from "@hotwired/stimulus";

// The registration form of a person: the button stays disabled until a level
// is chosen, and while the request runs the form says that Olin is working.
export default class extends Controller {
  static targets = ["submit", "busy"];

  changed() {
    this.submitTarget.disabled = !this.element.querySelector(
      "input[name='registration[registration_level_id]']:checked"
    );
  }

  start() {
    this.submitTarget.disabled = true;
    this.busyTarget.hidden = false;
  }

  finish() {
    this.busyTarget.hidden = true;
  }
}
